module.exports = [
	{
		"match": "cg-textures",
		"title": "More Textures",
		"content": "The CG textures you'll find here are made specifically for 3d. If you just need flat, tiled textures, be sure to check out the <a href=\"https://graphicriver.net/category/textures\">textures category</a> on GraphicRiver. ",
		"button_label": "Browse Textures",
		"icon_source": "photo_v4.png",
		"link": "https://3docean.net/category/cg-textures"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/ads/3docean.json
// module id = 464
// module chunks = 1